<template>
    <div class="table-responsive-md">
        <div v-if="dataset.length == resultsPerPage && isLoadingRemaining" class="row"><span aria-hidden="true" class="d-none d-lg-inline-block hidden-xs hidden-sm hidden-md"><span><img src="/static/img/ajax-loader.gif" :alt="trans('loading')" /> ${ trans("loading remaining athletes") } ...</span></span></div>
        <div v-if="ajax | dataset.length > resultsPerPage" class="row">
           <div class="col-md-4">
           <navigator @changePage="setPg" @movePage="mvPg">
                <literal msgid="prev" :msgstr="trans('prev')"></literal>
                <literal msgid="next" :msgstr="trans('next')"></literal>
                <literal msgid="previous" :msgstr="trans('previous')"></literal>
           </navigator>
           </div>
           <div class="col-md-3 d-flex align-items-end justify-content-end">
                <a v-for="link in downloads" :href="link.url"><span :class="link.icon" class="mr-1"></span>${link.label}</a>
           </div>
           <div class="col-md-5 my-1">
               <div class="input-group search-box">
                    <input type="text" :placeholder="trans('search')" class="form-control" v-model="searchBox">

                    <!-- if using ajax call then search needs a button to send api call -->
                    <span v-if="ajax" class="input-group-btn input-group-append">
                        <button @click="$emit('search', searchBox)" type="button" class="btn btn-sm btn-warning border-0">Go</button>
                    </span>
                    <!-- else we can have a button for clearing the search quickly -->
                    <span v-else class="input-group-btn input-group-append">
                        <button @click="searchBox=''" type="button" class="btn btn-sm btn-warning" :class="{disabled: searchBox.trim().length == 0}"><span class="fas fa-times glyphicon glyphicon-remove"></span></button>
                    </span>
               </div>
           </div>
        </div>
        <table class="table bg-white" style="border-radius: 10px; overflow: hidden;">
            <slot></slot>
            <thead>
               <tr> <th v-for="header in headings" :class="tdClass(header) + ' noselect'">
                    <funnel v-if="header.funnel" v-on:filtered="refilter" :key-name="header.val" :key-func="header.lookup || null"><span v-html="header.$el.innerHTML"></span></funnel>
                    <span v-else>
                       <sorter v-if="header.order" :ref="header.val+'Sorter'" v-on:reset="resetSort" v-on:sort="sortBy" :key-name="header.val"><span v-html="header.$el.innerHTML"></span></sorter>
                       <span v-else v-html="header.$el.innerHTML"></span>
                    </span>
                </th> </tr>
            </thead>
            <tbody>
                <tr v-for="(row, i) in funneledResults()" :key="row[pk]">
                    <td v-for="header in headings" :class="tdClass(header)">
                        <div v-if="header.flag || header.flag_url || row[header.val]" :title="header.lookup ? invoke(header.lookup, row, header, i) : header.tooltip ? invoke(header.tooltip, row, header, i) : (row[header.val] || '-')" :style="'background-image: url(' + safeFlag(row, header.flag || header.flag_url) + '); display: inline-block'" @error="$parent.handleBrokenImage" @click.once="$parent.tooltap"></div>
                        <a v-if="header.link" :class="invoke(header.innerClass, row, header, i)" :href="baseUrl + row[pk] + '/'">
                            <span v-if="header.lookup && header.flag || header.flag_url"><span class="hidden-xs">${ invoke(header.lookup, row, header, i) }</span><span class="visible-xs">${ row[header.val] || '' }</span></span>
                            <span v-else><span v-if="header.lookup">${ invoke(header.lookup, row, header, i) }</span>
                            <span v-else v-if="header.val">${ row[header.val] || '' }</span></span>
                        </a>
                        <span v-else :class="invoke(header.innerClass, row, header, i)" @click="header.action ? invoke(header.action, row, header, i) : false" :title="header.tooltip && invoke(header.tooltip, row, header, i)" @click.once="header.tooltip && invoke(header.tooltip, row, header, i) ? $parent.tooltap($event) : false">
                            <span v-if="header.lookup && !header.flag && !header.flag_url">
                                <span class="" v-html="invoke(header.lookup, row, header, i)"></span>
                                <span class="visible-xs" v-if="typeof(header.val) !== 'undefined'">${ row[header.val]  }</span>
                            </span>

                            {# if its a list of objects #}
                            <span v-if="header.datasetField && header.filter" >${ arrayFilter(row, header, i) }</span>

                            <span v-else v-if="header.val">${ row[header.val] || '' }</span>
                        </span>
                        <span v-if="header.extraVal && row[header.extraVal]" :class="header.extraVal">${ row[header.extraVal] }</span>
                        <span v-if="header.extraLookup && invoke(header.extraLookup, row, header, i)" :class="header.extraLookup">${ invoke(header.extraLookup, row, header, i) }</span>
                        <span v-if="header.lightbox && invoke(header.lightbox, row, header, i)">
                            <button v-if="isDialog(header.lighbox, row, header, i)" class="btn btn-sm" @click="openLightbox(row, header, i)"><span class="fa fa-mobile-alt glyphicon glyphicon-phone"></span></button>
                            <a v-else class="btn btn-sm" target="_blank" :title="trans('new_window')" :href="invoke(header.lightbox, row, header, i).url"><span class="fa fa-paperclip glyphicon glyphicon-paperclip"></span></a>
                    </td>
                </tr>
            </tbody>
        </table>
        <navigator @changePage="setPg" @movePage="mvPg">
            <literal msgid="prev" :msgstr="trans('prev')"></literal>
            <literal msgid="next" :msgstr="trans('next')"></literal>
            <literal msgid="previous" :msgstr="trans('previous')"></literal>
        </navigator>
    </div>
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'

// mixins
import translationMixin from '../assets/TranslationMixin.js'
import searchMixin from '../assets/SearchMixin.js'

// components
import translate from './Translation.vue'
import sheetFunnel from './SheetFunnel.vue'
import sheetLine from './SheetLine.vue'
import sorter from './Sorter.vue'

export default {
  delimiters: ['${', '}'],
  mixins: [searchMixin, translationMixin],
  components: [translate, sorter, sheetLine, sheetFunnel],
  props: {
    dataset: Array,
    pk: String,
    relatedDataset: Array,
    relatedFk: String,
    ajax: Boolean,
    baseUrl: String,
    resultsPerPage: {
      type: Number,
      default: function () { return 50 }
    },
    numPages: Number,
    total: Number,
    downloads: Array
  },
  data: function () {
    return {
      headings: [],
      sortKey: '',
      sortWays: [],
      sortKeys: [],
      filterMapping: {},
      page: 0
    }
  },
  watch: {
    page: function (val) {
      this.tooltipEmAll()
    }
  },
  methods: {
    safeFlag: function (rw, flagKey) {
      var flag = ''
      if (rw && rw.hasOwnProperty(flagKey) || rw && rw.hasOwnProperty('flag_url')) {
        flag = rw[flagKey] || ''
        if (flag !== '') {
          if (flag.length > 0 && flag.indexOf("'") > 0) {
            flag = flag.replace("'", "\\'")
          }
        }
      }

      return flag
    },
    tooltipEmAll: function (tm) {
      var self = this
      window.setTimeout(function (elf) {
        elf.find('[title]').tooltip()
      }, tm || 500, $(self.$el))
    },
    setPg: function (p) {
      if (this.$parent.setPg) {
        this.$parent.setPg(p)
      }
      this.page = p
    },
    mvPg: function (i) {
      if (this.$parent.mvPg) {
        this.$parent.mvPg(i)
      }
      this.page += i
    },
    tdClass: function (header) {
      var s = ''
      if (header.flag) {
        s += 'flg '
      }
      if (header.class) {
        s += header.class
      }
      if (header.$vnode.elm.className) {  // FIXME: too much introspection
        s += header.$vnode.elm.className
      }
      return s
    },
    sortBy: function (ref) {
      var self = this
      var sortKey = ref.keyName
      var dir = ref.direction
      var found = self.sortKeys.indexOf(sortKey)
      if (found > -1) {
        if (found === 0) {
          // just reverse the sorting order
          dir = dir || (self.sortWays[found] === 'asc' ? 'desc' : 'asc')
          self.sortWays[found] = dir
        } else {
          // remove from previous sorts
          self.sortKeys.splice(found, 1)
          self.sortWays.splice(found, 1)
          // and add anew
          self.sortKeys.unshift(sortKey)
          self.sortWays.unshift(dir || 'asc')
        }
      } else {
        self.sortKeys.unshift(sortKey)
        self.sortWays.unshift(dir || 'asc')
      }
      self.sortKey = sortKey
      self.sortWays = self.sortWays.slice(0, self.sortWays.length)
    },
    resetSort: function () {
      var self = this
      self.sortKeys = []
      self.sortWays = []
      self.sortKey = ''
      self.$children.forEach(function (a, idx) {
        if (a.direction) {
          a.direction = ''
        }
      })
    },
    refilter: function (ref) {
      var self = this
      var key = ref.keyName || ref.keyFunc
      if (ref.selected.length) {
        self.filterMapping[key] = ref.selected
      } else {
        if (self.filterMapping[key].indexOf(key)) {
          delete self.filterMapping[key]
        }
      }
      self.$forceUpdate()
    },
    invoke: function (param, row, header, i) {
      var self = this
      var out, h
      if (typeof (param) === 'undefined') {
        return ''
      } else {
        h = header.idx != null ? header.idx : i
        if (self.$parent[param]) {
          out = self.$parent[param](row, h, header)
        }
        return out || ''
      }
    },
    isDialog: function (param, row, header, i) {
      var self = this
      var xtra = self.invoke(header.lightbox, row, header, i)
      return xtra.isDialog
    },
    openLightbox: function (row, header, i) {
      var self = this
      var xtra = self.invoke(header.lightbox, row, header, i)
      var placeholder, src
      if (!$('#lightBox').length) {
        placeholder = '<div class="modal fade" id="lightBox" tabindex="-1" role="dialog" aria-labelledby="lightBoxTitle" aria-hidden="true">' +
                '<div class="modal-dialog" role="document">' +
                '  <div class="modal-content">' +
                '    <div class="modal-header">' +
                '      <button type="button" class="close pull-right float-right" data-dismiss="modal" aria-label="trans(\'close\')">' +
                '       <span aria-hidden="true">&times;</span>' +
                '      </button>' +
                '      <h4 class="modal-title" id="lightBoxTitle">' + (xtra.title || '') + '</h4>' +
                '    </div>' +
                '   <div class="modal-body" style="height: 430px">' +
                '         <iframe height="400" width="100%" src="/x/blank.html" allowtransparency="true" frameborder="0" style="border: 0 none"></iframe>' +
                '   </div></div></div>'
        $('body').append(placeholder)
      } else {
        $('#lightBox').find('#lightBoxTitle').text(xtra.title || '')
      }
      if (xtra.url.toLowerCase().trim().indexOf('<iframe') === 0) {
        // convert string to element and extract the `src` attr
        src = $(xtra.url)[0].src
      } else {
        src = xtra.url
      }
      $('#lightBox').find('iframe').attr('src', src)
      $('#lightBox').modal('show')
    },
    loadHeading: function (heading) {
      this.headings.push(heading)
    },
    funneledResults: function () {
      var self = this
      var results = self.sortedDataset
      var func, startIdx
      if (Object.keys(self.filterMapping).length) {
        for (var f in self.filterMapping) {
          if (self.$parent.hasOwnProperty(f)) {  // check first if it's a root method. Loosing here.
            func = self.$parent[f]
            results = _.filter(results, function (r) { return self.filterMapping[f].indexOf(func(r)) >= 0 })
          } else {
            if (self.dataKeys.indexOf(f) >= 0) {
              results = _.filter(results, function (r) { return self.filterMapping[f].indexOf(r[f]) >= 0 })
            }
          }
        }
      }
      if (self.resultsPerPage) {
        startIdx = self.getPageIdx(results)
        if (results) {
          return results.slice(startIdx, startIdx + self.resultsPerPage)
        }
        return []
      } else {
        return results
      }
    },
    getColNames: function (dataset) {
      if (dataset.length) {
        return Object.keys(dataset[0])
      } else {
        return []
      }
    },
    orderedList: function (collection = []) {
      var self = this
      var i = 0
      var keys = collection.length > 0 ? Object.keys(collection[0]) : []
      // attempt to strip off fields which are not in the collection
      for (; i < self.sortKeys.length; i++) {
        if (keys.indexOf(self.sortKeys[i]) < 0) {
          self.sortKeys.splice(i, 1)
          self.sortWays.splice(i, 1)
        }
      }
      if (self.sortKeys.length) {
        return _.orderBy(collection, self.sortKeys, self.sortWays)
      } else {
        return collection
      }
    },
    getPageIdx: function (res = []) {
      var self = this
      var idx = self.page * self.resultsPerPage
      if (res.length < idx) {
        self.page = 0
        idx = 0
      }
      return idx
    },
    arrayFilter: function (row, header, i) {
      if (row[header.datasetField]) {
        var dataset = row[header.datasetField].find(header.filter)
        if (dataset) {
          return dataset[header.val]
        }
      }
    }
  },
  computed: {
    filteredDataset: function () {
      var self = this
      var dataset = self.dataset.slice()
      if (self.searchBox.trim().length > 1) {
        dataset = self.filteredList(dataset)
      }

      if (self.ajax && !dataset.length) {
        return self.dataset.slice()
      }
      return dataset
    },
    sortedDataset: function () {
      var self = this
      var dataset = self.filteredDataset
      if (self.relatedFk) {
        dataset.forEach(function (d) {
          var related = _.find(self.relatedDataset, function (rd) { return rd[self.relatedFk] === d[self.pk] }) || {}
          var keys = Object.keys(d)
          var rk
          for (rk in related) {
            if (keys.indexOf(rk) < 0) {
              d[rk] = related[rk]
            }
          }
        })
      }
      if (self.sortKeys.length > 0) {
        return self.orderedList(dataset)
      } else {
        return dataset
      }
    },
    dataKeys: function () {
      return _.filter(_.map(this.headings, function (h) { return h.val || null }), function (m) { return m != null })
    },
    colNames: function () {
      return this.getColNames(this.dataset)
    },
    relatedColNames: function () {
      return this.getColNames(this.relatedDataset || [])
    },
    isLoadingRemaining: function () {
      return this.$root.isLoadingRemaining
    }
  }
}
</script>


// WEBPACK FOOTER //
// Sheet.vue?54e67e4c